<div class="chart-preview-wrapper">
  <div class="chart-preview-header" *ngIf="!hideHeader">
    <h3 nz-typography class="nfl-form-label">Chart Preview</h3>
    <button
      *ngIf="type === 'GEO'"
      nz-button
      nzType="text"
      nzSize="small"
      (click)="resetChart()"
      title="Reset Chart"
      class="reset-chart-btn"
    >
      <span nz-icon nzType="reload" nzTheme="outline"></span>
    </button>
  </div>
  <div nz-col nzSpan="22" nzOffset="1">
    <ng-container [ngSwitch]="type">
      <div
        *ngSwitchCase="'LINE'"
        #lineChart
        [ngClass]="{
          'chart-container': !isDashboardPreview,
          'dashboard-chart-container': isDashboardPreview,
        }"
        [ngStyle]="isDashboardPreview ? { height: temp.height - 20 + 'px' } : null"
      ></div>
      <div
        *ngSwitchCase="'BAR'"
        #barChart
        [ngClass]="{
          'chart-container': !isDashboardPreview,
          'dashboard-chart-container': isDashboardPreview,
        }"
        [ngStyle]="isDashboardPreview ? { height: temp.height - 20 + 'px' } : null"
      ></div>
      <div
        *ngSwitchCase="'PIE'"
        #pieChart
        [ngClass]="{
          'chart-container': !isDashboardPreview,
          'dashboard-chart-container': isDashboardPreview,
        }"
        [ngStyle]="isDashboardPreview ? { height: temp.height - 20 + 'px' } : null"
      ></div>
      <div
        *ngSwitchCase="'SCATTER'"
        #scatterChart
        [ngClass]="{
          'chart-container': !isDashboardPreview,
          'dashboard-chart-container': isDashboardPreview,
        }"
        [ngStyle]="isDashboardPreview ? { height: temp.height - 20 + 'px' } : null"
      ></div>
      <div
        *ngSwitchCase="'GEO'"
        #geoChart
        [ngClass]="{
          'chart-container': !isDashboardPreview,
          'dashboard-chart-container': isDashboardPreview,
        }"
        [ngStyle]="isDashboardPreview ? { height: temp.height - 20 + 'px' } : null"
      ></div>
      <div *ngSwitchDefault class="no-chart">
        <nz-result nzStatus="warning" nzTitle="Chart Preview not available">
          <div nz-result-extra>
            <p nz-typography>Please verify inputs for chart</p>
          </div>
        </nz-result>
      </div>
    </ng-container>
  </div>
</div>
